import * as React from 'react';
import { FileProps } from '../type';
import { File } from './File';

export const FileReject: React.SFC<FileProps> = (props) => (
  <File className="elmo-uploaded-file__rejected" {...props} />
);
